/**
 * 判断是否数字
 * @return {Boolean} 是否数字
 */
import isType from './is-type';

var isNumber = function (value) {
  return isType(value, 'Number');
};

export default isNumber;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/is-number.js
// module id = 5
// module chunks = 0